module.exports = __webpack_public_path__ + "static/img/img_11.45cc3d62.png";